/* eslint-disable react-hooks/exhaustive-deps */
import { ko } from 'date-fns/locale/ko';
import moment from 'moment';
import React, { useEffect, useRef, useState } from 'react';
import DatePicker, { registerLocale } from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useSearchParams } from 'react-router-dom';
import {
    deleteFilterPAEAA010Conditions,
    fetchInitialConditions,
    saveFilterPAEAA010Conditions,
    saveMatchingConditions,
} from '../../../redux/reducers/PAEAA010';
import {
    getPAAAA010recruit,
    getPAEAA010search,
    postPAEAA010list,
    putPAAAA010Banner,
    getListCode,
} from '../../../services/Api';
import Checkbox from '../../../shared/components/Checkbox';
import Dropdown from '../../../shared/components/Dropdown';
import Nav from '../../../shared/components/Nav';
import Radiobox from '../../../shared/components/Radiobox';
import Tabs from '../../../shared/components/Tabs';

import PaginationCustom from '../../../shared/components/PaginationCustom';
import RecruitList from '../../../shared/components/RecruitList';
import GrandBanner from '../../../shared/GrandBanner';
import { MENU_RECRUIT, MESSAGE } from '../../../shared/constants/app';
import { decodeToken, getCheckBoxValues, getDropdownValue, getRadioBoxValue } from '../../../utils';
import PAEAA060 from './popupPAEAA060';
import store from '../../../redux/store';
registerLocale('ko', ko);

const PAEAA010 = () => {
    const startDateRef = useRef(null);
    const endDateRef = useRef(null);

    const [loading, setLoading] = useState(false);
    const [isPopupOpen, setIsPopupOpen] = useState(false);
    const [popupData, setPopupData] = useState(null);
    const [resetTrigger, setResetTrigger] = useState(0);

    const [activeTabIndex, setActiveTabIndex] = useState(0);
    const [activeTabCheckbox, setActiveTabCheckbox] = useState(null);
    const [activeTabCheckbox2, setActiveTabCheckbox2] = useState(null);
    const [recruitLicenses, setRecruitLicenses] = useState([]);
    const [recruitForms, setRecruitForms] = useState([]);
    const [recruitPositions, setRecruitPositions] = useState([]);
    const [recruitPays, setRecruitPays] = useState([]);
    const [recruitDays, setRecruitDays] = useState([]);
    const [checkedLabels, setCheckedLabels] = useState([]);

    const [dataSubway, setDataSubway] = useState(0);
    const [subwayData, setSubwayData] = useState([]);
    const [subwayNum, setSubwayNum] = useState([]);
    const [subwayPost, setSubwayPost] = useState([]);
    const [filteredSubwayPost, setFilteredSubwayPost] = useState([]);
    const [num, setNum] = useState(null);

    const [recruitClass, setRecruitClass] = useState([]);
    const [recruitProvinces, setRecruitProvinces] = useState([]);
    const [recruitCommunes, setRecruitCommunes] = useState({});
    const [selectedProvince, setSelectedProvince] = useState(null);

    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');
    const [checkedValues, setCheckedValues] = useState({});
    const [checkedLikeRightValues, setCheckedLikeRightValues] = useState({});
    const [applyMethod, setApplyMethod] = useState({});
    const [applyMethodChecked, setApplyMethodChecked] = useState({
        ApplyMethod: [],
    });

    const [dataConFig, setDataConFig] = useState({
        countFixed: '',
        bannerConfig: '',
    });
    const [results, setResults] = useState([]);
    const [size, setSize] = useState(50);
    const [searchParams, setSearchParams] = useSearchParams();
    const page = Number(searchParams.get('page')) || 1;
    const [pages, setPages] = useState({});
    const [sortBy, setSortBy] = useState('ModDate');

    const [conditionSearch, setConditionSearch] = useState('CompanyName');
    const [keywords, setKeywords] = useState([]);

    const dispatch = useDispatch();

    const savedConditions = useSelector(({ PAEAA010 }) => PAEAA010.savedPAEAA010Conditions || []);

    const [savedConditionsPopup, setSavedConditionsPopup] = useState(false);
    const token = useSelector(({ auth }) => auth.login.token);
    const login = useSelector(({ auth }) => auth.login);
    const loggedIn = login.loggedIn;
    const navigate = useNavigate();
    const decode = decodeToken(token);
    const [viewImmediate, setViewImmediate] = useState(false);
    const popupRef = useRef(null);

    const [recruitBanner, setRecruitBanner] = useState([]);

    const [searchSuccess, setSearchSuccess] = useState(false);

    useEffect(() => {
        getPAAAA010recruit()
            .then(({ data }) => {
                setRecruitBanner(data.recruit);
                const listSeq = [data.recruit?.map((item) => item.seq).join(',')].filter((seq) => seq).join(',');
                if (listSeq.toString() === '') return;
                putPAAAA010Banner(listSeq.toString())
                    .then()
                    .catch((error) => console.log(error));
            })
            .catch((error) => console.log(error));
    }, []);

    const companyTypes = [
        { code: '001', codeName: '치과의원' },
        { code: '002', codeName: '치과병원' },
        { code: '003', codeName: '치과기공소' },
        { code: '004', codeName: '종합병원' },
        { code: '005', codeName: '네트워크치과' },
        { code: '006', codeName: '신규개원' },
        { code: '999', codeName: '일반(기타)' },
    ];
    // 학력: mỗi checkbox gom nhiều mã A10 (졸업), expand khi gửi payload
    const recruitGradeGroups = {
        HIGH: ['001'],
        COLLEGE: ['002', '003', '004', '005', '006', '007', '008', '009', '010'],
        GRADUATE: ['011', '012', '013'],
    };

    const getOptions = (name) => {
        const options = {
            RecruitLicense: recruitLicenses.map((license) => ({
                id: 'recruitLicenses_' + license.code,
                label: license.codeName,
                value: license.code,
            })),

            RecruitForm: recruitForms.map((form) => ({
                id: 'recruitForms_' + form.code,
                label: form.codeName,
                value: form.code,
            })),

            RecruitPosition: recruitPositions.map((position) => ({
                id: 'recruitPositions_' + position.code,
                label: position.codeName,
                value: position.codeName,
            })),

            RecruitPay: recruitPays.map((pay) => ({
                id: 'recruitPays_' + pay.code,
                label: pay.codeName,
                value: pay.code,
            })),

            RecruitGrade: [
                { id: 'recruitGrade_high', value: 'HIGH', label: '고등학교 졸업' },
                { id: 'recruitGrade_college', value: 'COLLEGE', label: '전문대/대학 졸업' },
                { id: 'recruitGrade_graduate', value: 'GRADUATE', label: '대학원 이상 졸업' },
            ],

            RecruitCareer: [
                { id: 'recruitCareers_999', value: '무관', label: '무관' },
                { id: 'recruitCareers_001', value: '신입', label: '신입' },
                { id: 'recruitCareers_009', value: '경력', label: '경력' },
            ],

            Assist1: [
                { id: 'assist1_101', value: '101', label: '기숙사지원' },
                { id: 'assist1_102', value: '102', label: '식대지원' },
            ],

            Assist2: [{ id: 'assist2_201', value: '201', label: '경조사지원' }],

            Assist3: [
                { id: 'assist3_301', value: '301', label: '자기계발비지원' },
                { id: 'assist3_302', value: '302', label: '연월차지원' },
                { id: 'assist3_303', value: '303', label: '휴가비지원' },
            ],
            Assist4: [{ id: 'assist4_401', value: '401', label: '4대보험지원' }],

            Assist5: [
                { id: 'assist5_501', value: '501', label: '연봉제' },
                { id: 'assist5_502', value: '502', label: '인센티브제' },
                { id: 'assist5_503', value: '503', label: '퇴직금지원' },
                { id: 'assist5_504', value: '504', label: '야근수당지원' },
                { id: 'assist5_505', value: '505', label: '기타' },
            ],

            RecruitDay: recruitDays.map((day) => ({
                id: 'recruitDays_' + day.code,
                label: day.codeName,
                value: day.code,
            })),

            ApplyMethod: [
                { id: 'ApplyMethod1', label: '온라인 즉시지원', value: '001' },
                { id: 'ApplyMethod2', label: '전화접수', value: '002' },
                { id: 'ApplyMethod3', label: '이메일접수', value: '003' },
                { id: 'ApplyMethod4', label: 'FAX접수', value: '004' },
                { id: 'ApplyMethod5', label: '우편접수', value: '005' },
            ],

            RecruiteCareerYear: [
                { value: '1', option: '1년' },
                { value: '2', option: '2년' },
                { value: '3', option: '3년' },
                { value: '4', option: '4년' },
                { value: '5', option: '5년' },
                { value: '6', option: '6년' },
                { value: '7', option: '7년' },
                { value: '8', option: '8년' },
                { value: '9', option: '9년' },
                { value: '10', option: '10년' },
                { value: '11', option: '11년' },
                { value: '12', option: '12년' },
                { value: '13', option: '13년' },
                { value: '14', option: '14년' },
                { value: '15', option: '15년' },
                { value: '16', option: '16년' },
                { value: '17', option: '17년' },
                { value: '18', option: '18년' },
                { value: '19', option: '19년' },
                { value: '20', option: '20년' },
                { value: '21', option: '21년' },
                { value: '22', option: '22년' },
                { value: '23', option: '23년' },
                { value: '24', option: '24년' },
                { value: '25', option: '25년' },
                { value: '26', option: '26년' },
                { value: '27', option: '27년' },
                { value: '28', option: '28년' },
                { value: '29', option: '29년' },
                { value: '30', option: '30년' },
            ],
            CompanyType: companyTypes.map((item) => ({
                id: 'companyTypes_' + item.code,
                label: item.codeName,
                value: item.code,
            })),
            RecruitClass: recruitClass.map((item) => ({
                id: 'recruitClass_' + item.code,
                label: item.codeName,
                value: item.code,
            })),
            SubwayNum: subwayNum.map((item) => ({
                id: 'subwayNum_' + item.code,
                label: item.codeName,
                value: item.code,
            })),
            SubwayPost: filteredSubwayPost.map((item) => ({
                id: 'subwayPost_' + item.code,
                label: item.codeName,
                value: item.code,
            })),
        };

        desctCodes.forEach((desct) => {
            options[`SubwayNum${desct}`] = subwayNum
                .filter((item) => item.desct === desct)
                .map((item) => ({
                    id: 'subwayNum_' + item.code,
                    label: item.codeName,
                    value: item.code,
                    desct: desct,
                }));
        });

        return options[name];
    };

    const arrTabCheckbox = {
        0: (recruitProvinces?.filter((p) => p.code === '001') || []).map((p) => ({
            id: `RecruitLicense_${p.code}`,
            value: p.code,
            label: p.codeName,
        })),
        1: (recruitProvinces?.filter((p) => p.code === '003') || []).map((p) => ({
            id: `RecruitLicense_${p.code}`,
            value: p.code,
            label: p.codeName,
        })),
        2: (recruitProvinces?.filter((p) => p.code === '008') || []).map((p) => ({
            id: `RecruitLicense_${p.code}`,
            value: p.code,
            label: p.codeName,
        })),
        3: (recruitProvinces?.filter((p) => p.code === '009') || []).map((p) => ({
            id: `RecruitLicense_${p.code}`,
            value: p.code,
            label: p.codeName,
        })),

        4: (recruitProvinces?.filter((p) => ['006', '010', '011', '017'].includes(p.code)) || []).map((p) => ({
            id: `RecruitLicense_${p.code}`,
            value: p.code,
            label: p.codeName,
        })),
        5: (recruitProvinces?.filter((p) => ['002', '004', '007', '014', '015'].includes(p.code)) || []).map((p) => ({
            id: `RecruitLicense_${p.code}`,
            value: p.code,
            label: p.codeName,
        })),
        6: (recruitProvinces?.filter((p) => ['005', '012', '013', '016'].includes(p.code)) || []).map((p) => ({
            id: `RecruitLicense_${p.code}`,
            value: p.code,
            label: p.codeName,
        })),
    };

    const arrTabCheckbox2 = {
        0: (subwayNum?.filter((item) => ['001', '006'].includes(item.desct)) || []).map((item) => ({
            id: `subwayNum_${item.code}`,
            value: item.code,
            label: item.codeName,
        })),
        1: (subwayNum?.filter((item) => item.desct === '002') || []).map((item) => ({
            id: `subwayNum_${item.code}`,
            value: item.code,
            label: item.codeName,
        })),
        2: (subwayNum?.filter((item) => item.desct === '004') || []).map((item) => ({
            id: `subwayNum_${item.code}`,
            value: item.code,
            label: item.codeName,
        })),
        3: (subwayNum?.filter((item) => item.desct === '005') || []).map((item) => ({
            id: `subwayNum_${item.code}`,
            value: item.code,
            label: item.codeName,
        })),
        4: (subwayNum?.filter((item) => item.desct === '006') || []).map((item) => ({
            id: `subwayNum_${item.code}`,
            value: item.code,
            label: item.codeName,
        })),
    };

    // tabs
    const handleTabChange = (index) => {
        setConditionSearch('CompanyName');
        setActiveTabIndex(index);

        // Nếu chuyển giữa nhóm tab (1,2) <-> 3 thì reset
        const isCurrentTabGroup1or2 = activeTabIndex === 0 || activeTabIndex === 1;
        const isCurrentTabGroup3 = activeTabIndex === 2;
        const isNextTabGroup1or2 = index === 0 || index === 1;
        const isNextTabGroup3 = index === 2;

        if ((isCurrentTabGroup3 && isNextTabGroup1or2) || (isCurrentTabGroup1or2 && isNextTabGroup3)) {
            handleResetConditions();

            setCheckedValues((prev) => {
                const newValues = { ...prev };
                delete newValues.RegionSi;
                delete newValues.RegionGu;
                return newValues;
            });

            setActiveTabCheckbox(null);
        }
    };

    const tabCheckbox = [
        { label: '서울', isActive: false },
        { label: '인천', isActive: false },
        { label: '경기권', isActive: false },
        { label: '강원권', isActive: false },
        { label: '충청권', isActive: false },
        { label: '영남권', isActive: false },
        { label: '호남/제주권', isActive: false },
    ];

    const tabCheckbox2 = [
        { label: '수도권', isActive: false },
        { label: '부산', isActive: false },
        { label: '대구', isActive: false },
        { label: '광주', isActive: false },
        { label: '대전', isActive: false },
    ];

    const handleTabSelectCheckbox = (index) => {
        setCheckedPin(false);
        setActiveTabCheckbox(index);
    };

    const handleTabSelectCheckbox2 = (index) => {
        setCheckedPin(false);
        setActiveTabCheckbox2(index);
    };

    const desctCodes = ['001', '002', '004', '005', '006'];

    const getStructuredData = () => {
        if (!subwayNum || !subwayPost) return {};

        let structuredData = {};

        desctCodes.forEach((desct) => {
            structuredData[`subwayNum_${desct}`] = subwayNum
                .filter((num) => num.desct === desct)
                .map((num) => ({
                    code: num.code,
                    codeName: num.codeName,
                    desct: num.desct,
                    kind: num.kind,
                    subwayPost: subwayPost
                        .filter((post) => post.desct === num.code)
                        .map((post) => ({
                            code: post.code,
                            codeName: post.codeName,
                            desct: post.desct,
                            kind: post.kind,
                        })),
                }));
        });

        return structuredData;
    };

    useEffect(() => {
        const structuredData = getStructuredData();
        setSubwayData(structuredData);
        // eslint-disable-next-line
    }, [subwayNum, subwayPost]);

    // dropdown
    const handleOptionChange = (selectedValue, name) => {
        switch (name) {
            case 'size':
                setSize(selectedValue);
                break;
            case 'sortBy':
                setSortBy(selectedValue);
                break;
            case 'conditionSearch':
                setConditionSearch(selectedValue);
                break;
            default:
                setCheckedValues((checkedValues) => getDropdownValue(checkedValues, name, selectedValue));
                break;
        }
    };

    // select box, radio box
    const handleInputChange = (e) => {
        const { name, value, checked, type, id } = e.target;
        if (name === 'subwayNum') {
            handleNumClick(value);
        }
        if (name === 'RegionSi') {
            handleRegionSiClick(value);
        }

        setCheckedLikeRightValues((prevCheckedLikeRightValues) => {
            let newCheckedLikeRightValues = { ...prevCheckedLikeRightValues };

            if (
                (type === 'checkbox' && name === 'RecruitPosition') ||
                (type === 'checkbox' && name === 'RecruitClass') ||
                (type === 'checkbox' && name === 'RecruitForm') ||
                (type === 'checkbox' && name === 'RecruitLicense')
            ) {
                newCheckedLikeRightValues = getCheckBoxValues(newCheckedLikeRightValues, name, value, checked);
                const option = getOptions(name)?.find((opt) => opt.value === value);

                if (!option) {
                    return newCheckedLikeRightValues;
                }

                if (checked) {
                    newCheckedLikeRightValues.RecruitPosition = [
                        ...(newCheckedLikeRightValues.RecruitPosition || []),
                        option.checked,
                    ];
                } else {
                    newCheckedLikeRightValues.RecruitPosition = (
                        newCheckedLikeRightValues.RecruitPosition || []
                    ).filter((item) => item !== option.checked);
                }

                newCheckedLikeRightValues.RecruitPosition = (newCheckedLikeRightValues.RecruitPosition || []).filter(
                    (item) => item !== null && item !== undefined,
                );

                if (newCheckedLikeRightValues.RecruitPosition.length === 0) {
                    delete newCheckedLikeRightValues.RecruitPosition;
                }
            }

            return newCheckedLikeRightValues;
        });

        setCheckedValues((checkedValues) => {
            let newCheckedValues = { ...checkedValues };

            if (
                type === 'checkbox' &&
                name !== 'ApplyMethod' &&
                name !== 'RecruitPosition' &&
                name !== 'RecruitClass'
            ) {
                // lấy value checkbox
                newCheckedValues = getCheckBoxValues(newCheckedValues, name, value, checked);

                // bỏ chọn '경력': reset expMin và expMax
                if (name === 'RecruitCareer' && value === '경력' && !checked) {
                    delete newCheckedValues.ExpMax;
                    delete newCheckedValues.ExpMin;
                }

                if (name === 'CompanyType') {
                    const companyType = newCheckedValues['CompanyType'] || [];
                    if (checked) {
                        // Chỉ thêm giá trị nếu chưa tồn tại
                        if (!companyType.includes(value)) {
                            newCheckedValues['CompanyType'] = [...companyType, value];
                        }
                    } else {
                        // Loại bỏ giá trị nếu đã tồn tại
                        newCheckedValues['CompanyType'] = companyType.filter((item) => item !== value);

                        // Xóa key nếu mảng rỗng
                        if (newCheckedValues['CompanyType'].length === 0) {
                            delete newCheckedValues['CompanyType'];
                        }
                    }
                }

                // kiểm tra nếu là RegionGu, cập nhật RegionSi tương ứng
                if (name === 'RegionGu') {
                    const selectedRegionSi = Object.entries(recruitCommunes).find(([key, communes]) =>
                        communes.some((commune) => commune.code === value),
                    );

                    if (selectedRegionSi) {
                        const [regionSiCode] = selectedRegionSi;
                        const currentRegionSi = newCheckedValues.RegionSi || [];
                        const currentRegionGu = newCheckedValues.RegionGu || [];

                        if (checked) {
                            if (value.endsWith('00')) {
                                const regionGuCodes =
                                    recruitCommunes[regionSiCode]?.map((commune) => commune.code) || [];
                                newCheckedValues.RegionGu = currentRegionGu.filter(
                                    (guCode) => !regionGuCodes.includes(guCode),
                                );
                                newCheckedValues.RegionGu.push(value);
                            } else {
                                const regionGuEndingWith00 = currentRegionGu.find((guCode) => guCode.endsWith('00'));
                                if (regionGuEndingWith00) {
                                    newCheckedValues.RegionGu = currentRegionGu.filter(
                                        (guCode) => guCode !== regionGuEndingWith00,
                                    );
                                }

                                if (!newCheckedValues.RegionGu.includes(value)) {
                                    newCheckedValues.RegionGu.push(value);
                                }
                            }

                            if (!currentRegionSi.includes(regionSiCode)) {
                                newCheckedValues.RegionSi = [...currentRegionSi, regionSiCode];
                            }
                        } else {
                            newCheckedValues.RegionGu = currentRegionGu.filter((guCode) => guCode !== value);

                            const remainingRegionGu = newCheckedValues.RegionGu || [];
                            const isRegionSiStillRelevant = recruitCommunes[regionSiCode]?.some((commune) =>
                                remainingRegionGu.includes(commune.code),
                            );

                            if (!isRegionSiStillRelevant) {
                                newCheckedValues.RegionSi = currentRegionSi.filter((code) => code !== regionSiCode);
                                if (newCheckedValues.RegionSi.length === 0) {
                                    delete newCheckedValues.RegionSi;
                                }
                            }
                        }
                    }
                }
                if (name === 'SubwayPost') {
                    const selectedSubwayNum = String(getCodeNameAndParentLabel(value).codeParent);

                    if (selectedSubwayNum) {
                        const SubwayNumCode = String(selectedSubwayNum);
                        const currentSubwayNum = newCheckedValues.subwayNum
                            ? newCheckedValues.subwayNum.map(String)
                            : [];

                        if (checked) {
                            if (!currentSubwayNum.includes(SubwayNumCode)) {
                                newCheckedValues.subwayNum = [...currentSubwayNum, SubwayNumCode];
                            }
                        } else {
                            const remainingSubwayPost = newCheckedValues.SubwayPost || [];
                            const isSubwayNumStillRelevant = recruitCommunes[SubwayNumCode]?.some((commune) =>
                                remainingSubwayPost.includes(commune.code),
                            );

                            if (!isSubwayNumStillRelevant) {
                                newCheckedValues.subwayNum = currentSubwayNum.filter((code) => code !== SubwayNumCode);
                                if (newCheckedValues.subwayNum.length === 0) {
                                    delete newCheckedValues.subwayNum;
                                }
                            }
                        }
                    }
                }
            } else if (type === 'radio') {
                // lấy value radio
                newCheckedValues = getRadioBoxValue(newCheckedValues, name, value, checked);
            }

            return newCheckedValues;
        });

        setApplyMethod((prevApplyMethod) => {
            let newApplyMethod = { ...prevApplyMethod };

            if (type === 'checkbox' && name === 'ApplyMethod') {
                const methodId = id;

                if (checked) {
                    if (!newApplyMethod[methodId]) {
                        newApplyMethod[methodId] = [];
                    }

                    if (!newApplyMethod[methodId].includes(value)) {
                        newApplyMethod[methodId].push(value);
                    }
                } else {
                    if (newApplyMethod[methodId]) {
                        newApplyMethod[methodId] = newApplyMethod[methodId].filter((item) => item !== value);

                        // Nếu không còn value nào, xóa key methodId
                        if (newApplyMethod[methodId].length === 0) {
                            delete newApplyMethod[methodId];
                        }
                    }
                }
            }

            return newApplyMethod;
        });
    };

    const getCodeNameAndParentLabel = (code) => {
        for (const key in subwayData) {
            if (Array.isArray(subwayData[key])) {
                for (const item of subwayData[key]) {
                    const found = item.subwayPost.find((post) => post.code === code);
                    if (found) {
                        return {
                            child: found.codeName,
                            codeChild: found.code,
                            parent: item.codeName,
                            codeParent: item.code,
                        };
                    }
                }
            }
        }
        return null;
    };

    // datetime input
    const handleDateChange = (date, name) => {
        if (name === 'startDate') {
            setStartDate(date);
        } else if (name === 'endDate') {
            setEndDate(date);
        }
    };

    // tab 1
    useEffect(() => {
        if (recruitProvinces.length > 0) {
            setSelectedProvince(recruitProvinces[0].code);
        }
    }, [recruitProvinces]);

    const handleProvinceClick = (code) => {
        setSelectedProvince(code);
    };

    const communesToRender = recruitCommunes[selectedProvince] || [];

    // tab 2
    const handleCheckRecruitClass = (code) => {
        setCheckedLikeRightValues((prevValues) => {
            const newValues = { ...prevValues };
            const recruitClass = newValues['RecruitClass'] || [];

            if (recruitClass.includes(code)) {
                newValues['RecruitClass'] = recruitClass.filter((item) => item !== code);
            } else {
                newValues['RecruitClass'] = [...recruitClass, code];
            }

            if (newValues['RecruitClass'].length === 0) {
                delete newValues['RecruitClass'];
            }

            return newValues;
        });
    };

    const handleInputKeyPress = (e) => {
        if (e.key === 'Enter') {
            e.preventDefault();

            const inputValue = e.target.value.trim();
            const inputName = e.target.name;

            if (inputValue) {
                if (keywords.length >= 3) {
                    return;
                }

                setCheckedLikeRightValues((prevValues) => {
                    const newValues = { ...prevValues };

                    if (inputName === 'searchAll') {
                        // thêm inputValue vào 'CompanyName', 'Title', và 'FTS_Contents'
                        ['CompanyName', 'Title', 'FTS_Contents'].forEach((key) => {
                            if (!newValues[key]) {
                                newValues[key] = [];
                            }

                            // thêm giá trị vào khóa tương ứng nếu nó chưa có ở đó
                            if (!newValues[key].includes(inputValue)) {
                                newValues[key].push(inputValue);
                            }
                        });
                    } else {
                        if (!newValues[conditionSearch]) {
                            newValues[conditionSearch] = [];
                        }
                        const updatedKeywords = [...newValues[conditionSearch], inputValue];
                        newValues[conditionSearch] = [...new Set(updatedKeywords)];
                    }

                    return newValues;
                });

                setKeywords((prevKeywords) => {
                    const updatedKeywords = [...prevKeywords, inputValue];
                    return [...new Set(updatedKeywords)];
                });

                e.target.value = '';
            }
        }
    };

    // get label
    const getCheckedLabels = () => {
        const labels = [];
        const startDateChecked =
            startDate !== undefined && moment(startDate).isValid() ? moment(startDate).format('yyyy-MM-DD') : '';
        const endDateChecked =
            endDate !== undefined && moment(endDate).isValid() ? moment(endDate).format('yyyy-MM-DD') : '';

        // lấy label từ checkedLikeRightValues
        checkedLikeRightValues &&
            Object.entries(checkedLikeRightValues || {}).forEach(([key, values]) => {
                if (key === 'RecruitClass') {
                    const valueArray = Array.isArray(values) ? values : [values];
                    valueArray.forEach((code) => {
                        const recruit = recruitClass?.find((item) => item.code === code);

                        if (recruit) {
                            labels.push(recruit.codeName);
                        }
                    });
                }

                if (key === 'RecruitPosition') {
                    const valueArray = Array.isArray(values)
                        ? values
                            .map((name) => {
                                const recruit = recruitPositions.find((item) => item.codeName === name);
                                return recruit ? recruit.code : null;
                            })
                            .filter((code) => code !== null)
                        : [values];

                    valueArray.forEach((code) => {
                        const recruit = recruitPositions.find((item) => item.code === code);
                        if (recruit) {
                            labels.push(recruit.codeName);
                        }
                    });
                }
            });

        // lấy label từ checkedValues
        Object.entries(checkedValues || {}).forEach(([key, values]) => {
            if (key === 'RegionGu') {
                const valueArray = Array.isArray(values) ? values : [values];

                valueArray.forEach((value) => {
                    // tìm RegionSi chứa RegionGu này
                    const regionSiEntry = Object.entries(recruitCommunes)?.find(([regionSiCode, communes]) =>
                        communes.some((commune) => commune.code === value),
                    );

                    if (regionSiEntry) {
                        const [regionSiCode] = regionSiEntry;

                        // tìm tên RegionSi từ recruitProvinces
                        const regionSi = recruitProvinces.find((province) => province.code === regionSiCode);

                        // tìm thông tin RegionGu
                        const commune = recruitCommunes[regionSiCode]?.find((commune) => commune.code === value);

                        if (regionSi && commune) {
                            labels.push(`${regionSi.codeName} > ${commune.codeName}`);
                        }
                    }
                });
            }
            if (key === 'SubwayPost') {
                const valueArray = Array.isArray(values) ? values : [values];
                valueArray.forEach((value) => {
                    const codeName = getCodeNameAndParentLabel(value);
                    labels.push(`${codeName.parent} > ${codeName.child}`);
                });
            } else {
                const options = getOptions(key);
                const expMin = checkedValues.ExpMin !== undefined ? checkedValues.ExpMin + '년' : '';
                const expMax = checkedValues.ExpMax !== undefined ? checkedValues.ExpMax + '년' : '';

                if (!options) return;

                const valueArray = Array.isArray(values) ? values : [values];
                valueArray.forEach((value) => {
                    const matchedOption = options?.find((option) => option.value === value);
                    if (matchedOption) {
                        if (key === 'RecruitCareer' && value === '경력') {
                            labels.push(`경력: ${expMin} ~ ${expMax}`);
                        } else {
                            labels.push(matchedOption.option || matchedOption.label); // Dùng option nếu có
                        }
                    }
                });
            }
        });

        // lấy label từ applyMethod
        const flatApplyMethodValues = Object.values(applyMethod || {}).flat();
        flatApplyMethodValues.forEach((value) => {
            const options = getOptions('ApplyMethod');

            const matchedOption = options.find((option) => option.value === value);

            if (matchedOption) {
                labels.push(matchedOption.label);
            }
        });

        if (keywords && keywords.length > 0) {
            keywords.forEach((keyword) => {
                labels.push(keyword);
            });
        }

        if (startDate || endDate) {
            labels.push(`채용기간: ${startDateChecked} ~ ${endDateChecked}`);
        }

        return labels;
    };

    // remove label
    const handleRemoveLabel = (label) => {
        // xử lý xóa StartDate và EndDate
        if (label.startsWith('채용기간:')) {
            setStartDate('');
            setEndDate('');
        }

        setCheckedValues((prevValues) => {
            const newValues = { ...prevValues };

            const [regionSiName, regionGuName] = label.split(' > ');
            const [subwayNumName, SubwayPostName] = label.split(' > ');

            // duyệt qua các key trong checkedValues
            Object.entries(newValues).forEach(([key, values]) => {
                const options = getOptions(key);

                // xử lý xóa RecruitCareer với giá trị '경력'
                if (key === 'RecruitCareer' && label.startsWith('경력:')) {
                    // xóa expMin và expMax khi label là dạng 경력: X ~ Y
                    delete newValues.ExpMin;
                    delete newValues.ExpMax;

                    // chỉ bỏ '경력', giữ lại các lựa chọn khác (무관, 신입)
                    const remaining = (Array.isArray(values) ? values : [values]).filter((v) => v !== '경력');
                    if (remaining.length === 0) {
                        delete newValues[key];
                    } else {
                        newValues[key] = remaining;
                    }
                    return;
                }

                // xử lý RegionGu
                if (key === 'RegionGu') {
                    // tìm RegionSi liên kết với RegionGu từ recruitCommunes
                    const matchedCommune = Object.entries(recruitCommunes).find(([regionSiCode, communes]) => {
                        const regionSi = recruitProvinces.find((province) => province.code === regionSiCode);
                        return (
                            regionSi &&
                            regionSi.codeName === regionSiName &&
                            communes.some((commune) => commune.codeName === regionGuName)
                        );
                    });

                    if (matchedCommune) {
                        const [regionSiCode, communes] = matchedCommune;

                        // loại bỏ RegionGu được chọn khỏi checkedValues
                        const communeToRemove = communes.find((commune) => commune.codeName === regionGuName);
                        if (communeToRemove) {
                            newValues.RegionGu = newValues.RegionGu.filter((code) => code !== communeToRemove.code);
                            // nếu RegionGu trống, xóa luôn key RegionGu
                            if (newValues.RegionGu.length === 0) {
                                delete newValues.RegionGu;
                            }

                            // kiểm tra nếu RegionSi còn liên kết với các RegionGu khác
                            const remainingRegionGu = newValues.RegionGu || [];
                            const isRegionSiStillRelevant = communes.some((commune) =>
                                remainingRegionGu.includes(commune.code),
                            );

                            if (!isRegionSiStillRelevant) {
                                // loại bỏ RegionSi nếu không còn liên kết
                                newValues.RegionSi = (newValues.RegionSi || []).filter((code) => code !== regionSiCode);

                                if (newValues.RegionSi.length === 0) {
                                    delete newValues.RegionSi;
                                }
                            }
                        }
                    }
                }

                // xử lý SubwayPost
                if (key === 'SubwayPost') {
                    let result = [];

                    Object.values(subwayData || {}).forEach((subwayList) => {
                        subwayList.forEach((num) => {
                            if (num.codeName === subwayNumName) {
                                let matchedPosts = num.subwayPost.filter((post) => post.codeName === SubwayPostName);
                                if (matchedPosts.length > 0) {
                                    result.push({ ...num, subwayPost: matchedPosts });
                                }
                            }
                        });

                        if (subwayList) {
                            subwayList.forEach((num, index) => {
                                const subwayPostList = subwayList[index].subwayPost;
                                const subwayPostToRemove = subwayPostList.find(
                                    (item) => item.codeName === SubwayPostName,
                                );
                                if (subwayPostToRemove && Array.isArray(newValues.SubwayPost)) {
                                    newValues.SubwayPost = newValues.SubwayPost.filter(
                                        (code) => code !== subwayPostToRemove.code,
                                    );
                                    // nếu SubwayNum trống, xóa luôn key SubwayNum
                                    if (newValues.SubwayPost.length === 0) {
                                        delete newValues.subwayNum;
                                        delete newValues.SubwayPost;
                                    }
                                }
                            });
                        }
                    });
                }

                // xử lý các giá trị khác
                if (!options) return;

                // tìm value tương ứng với label
                const matchedOption = options.find((option) => option.label === label);
                if (matchedOption) {
                    if (Array.isArray(values)) {
                        // nếu là mảng (checkbox), loại bỏ giá trị tương ứng
                        newValues[key] = values.filter((value) => value !== matchedOption.value);
                        if (newValues[key].length === 0) {
                            delete newValues[key];
                        }
                    } else if (values === matchedOption.value) {
                        // nếu là giá trị đơn (radio, select), đặt lại giá trị
                        delete newValues[key];
                    }
                }
            });
            return newValues;
        });

        setCheckedLikeRightValues((prevValues) => {
            const newValues = { ...prevValues };
            // xóa dữ liệu trong checkedLikeRightValues
            Object.entries(prevValues || {}).forEach(([key, values]) => {
                if (key === 'RecruitClass') {
                    values.forEach((code, index) => {
                        const recruit = recruitClass.find((item) => item.code === code && item.codeName === label);
                        if (recruit) {
                            newValues['RecruitClass'] = [...values.slice(0, index), ...values.slice(index + 1)];
                        }
                    });
                    if (newValues['RecruitClass'].length === 0) {
                        delete newValues['RecruitClass'];
                    }
                } else if (key === 'RecruitPosition') {
                    const filteredValues = values.filter((code) => code !== label);

                    if (filteredValues.length > 0) {
                        newValues['RecruitPosition'] = filteredValues;
                    } else {
                        delete newValues['RecruitPosition'];
                    }
                }
                else if (key === 'RecruitLicense') {
                    values.forEach((code, index) => {
                        const recruit = recruitLicenses.find((item) => item.code === code && item.codeName === label);
                        if (recruit) {
                            newValues['RecruitLicense'] = [...values.slice(0, index), ...values.slice(index + 1)];
                        }
                    });
                    if (newValues['RecruitLicense'].length === 0) {
                        delete newValues['RecruitLicense'];
                    }
                }
                else if (key === 'RecruitForm') {
                    values.forEach((code, index) => {
                        const recruit = recruitForms.find((item) => item.code === code && item.codeName === label);
                        if (recruit) {
                            newValues['RecruitForm'] = [...values.slice(0, index), ...values.slice(index + 1)];
                        }
                    });
                    if (newValues['RecruitForm'].length === 0) {
                        delete newValues['RecruitForm'];
                    }
                }
            });

            return newValues;
        });

        setApplyMethod((prevValues) => {
            const newValues = { ...prevValues };
            const options = getOptions('ApplyMethod');

            Object.entries(newValues).forEach(([key, values]) => {
                const valueArray = Array.isArray(values) ? values : [values];

                const matchedOption = options.find((option) => valueArray.includes(option.value));

                if (matchedOption && matchedOption.label === label) {
                    delete newValues[key];
                }
            });

            return newValues;
        });

        // xóa khỏi keywords và các trường 'CompanyName', 'Title', 'FTS_Contents'
        const isKeywordLabel = label && keywords.includes(label); // kiểm tra có trong keywords list không

        if (isKeywordLabel) {
            // xóa keyword khỏi `keywords` state
            const keywordToRemove = label;

            setKeywords((prevKeywords) => {
                return prevKeywords.filter((keyword) => keyword !== keywordToRemove);
            });

            // xóa keyword khỏi `CompanyName`, `Title`, `FTS_Contents` trong checkedLikeRightValues
            setCheckedLikeRightValues((prevValues) => {
                const newValues = { ...prevValues };

                ['CompanyName', 'Title', 'FTS_Contents'].forEach((field) => {
                    if (newValues[field]) {
                        // loại bỏ keyword khỏi các trường này
                        newValues[field] = newValues[field].filter((value) => value !== keywordToRemove);

                        // nếu trường trống sau khi xóa keyword, xóa luôn key đó
                        if (newValues[field].length === 0) {
                            delete newValues[field];
                        }
                    }
                });

                return newValues;
            });
        }

        // xóa label khỏi danh sách `checkedLabels`
        setCheckedLabels((prevLabels) => prevLabels.filter((l) => l !== label));
    };

    useEffect(() => {
        if (loggedIn) {
            dispatch(fetchInitialConditions());
        }
    }, [dispatch, loggedIn]);

    const handleSaveConditions = () => {
        const savedDate = moment().format('YYYY/MM/DD');
        if (window.location.pathname !== '/login' && window.location.pathname !== '/' && !loggedIn) {
            if (window.confirm(`회원전용입니다.\n로그인 하신후 이용하실 수 있습니다.\n로그인하시겠습니까?`)) {
                navigate('/login');
            } else {
                alert(`회원이 아닌경우 회원가입후 이용가능합니다.`);
                navigate('/');
            }
            return;
        }
        if (
            checkedLikeRightValues &&
            Object.keys(checkedLikeRightValues).length === 0 &&
            checkedValues &&
            Object.keys(checkedValues).length === 0 &&
            Object.keys(applyMethod).length === 0 &&
            startDate === '' &&
            endDate === '' &&
            checkedLabels.length === 0
        )
            return;

        const currentConditions = store.getState().PAEAA010.savedPAEAA010Conditions;
        if (currentConditions.length >= 5) {
            window.alert('최대 저장가능한 개수는 5개 입니다.');
            return;
        }

        dispatch(
            saveFilterPAEAA010Conditions({
                checkedLikeRightValues,
                checkedValues,
                applyMethod,
                startDate: startDate ? moment(startDate).format('YYYY/MM/DD') : '',
                endDate: endDate ? moment(endDate).format('YYYY/MM/DD') : '',
                savedDate,
                checkedLabels,
                activeTabIndex,
                activeTabCheckbox,
                activeTabCheckbox2,
            }),
        );

        dispatch(saveMatchingConditions(decode.seq));

        window.alert(MESSAGE.notify.saveSuccess);
    };

    const handleResetConditions = () => {
        setResetTrigger((prev) => prev + 1);
        setCheckedLikeRightValues({});
        setCheckedValues({});
        setCheckedLabels([]);
        setStartDate('');
        setEndDate('');
        setKeywords([]);
        setApplyMethod({});
        setActiveTabCheckbox(null);
        setActiveTabCheckbox2(null);
        setNum(null);
        setCheckedRegionSi(null);
    };

    useEffect(() => {
        setCheckedLabels(getCheckedLabels);
        // eslint-disable-next-line
    }, [checkedValues, checkedLikeRightValues, recruitClass, startDate, endDate]);

    useEffect(() => {
        getPAEAA010search()
            .then(({ data }) => {
                setRecruitProvinces(data.recruitProvinces);
                setRecruitCommunes(data.recruitCommunes);
                setRecruitLicenses(data.recruitLicense);
                setRecruitForms(data.recruitForm);
                setRecruitPositions(data.recruitPosition);
                setRecruitPays(data.recruitPay);
                setRecruitClass(data.recruitClass);
                setRecruitDays(data.recruitDay);
            })
            .catch((error) => console.log(error));

        getListCode('A16,A17')
            .then(({ data }) => {
                setSubwayNum(data.A16);
                setSubwayPost(data.A17);
                setDataSubway(1);
            })
            .catch((error) => console.log(error));
    }, []);

    useEffect(() => {
        const method = Object.values(applyMethod || {}).flat();
        setApplyMethodChecked({
            ApplyMethod: method,
        });
    }, [applyMethod]);

    const handleClickOutSidePopup = (e) => {
        if (popupRef.current && !popupRef.current.contains(e.target)) {
            setSavedConditionsPopup(false);
        }
    };

    useEffect(() => {
        if (savedConditionsPopup) {
            document.addEventListener('mousedown', handleClickOutSidePopup);
            return () => {
                document.removeEventListener('mousedown', handleClickOutSidePopup);
            };
        }
    }, [savedConditionsPopup]);

    const getListData = (currentPage = page) => {
        setLoading(true);
        setResults([]);
        const startDateFormat = startDate === '' ? null : moment(startDate).format('yyyy-MM-DD');
        const endDateFormat = endDate === '' ? null : moment(endDate).format('yyyy-MM-DD');
        const subwayNum = checkedValues?.subwayNum || null;
        const subwayPost = checkedValues?.SubwayPost || null;
        const expMin = checkedValues?.ExpMin?.[0] || '';
        const expMax = checkedValues?.ExpMax?.[0] || '';
        let optionsCopy = { ...checkedValues };
        delete optionsCopy.SubwayPost;
        delete optionsCopy.subwayNum;
        delete optionsCopy.ExpMin;
        delete optionsCopy.ExpMax;
        delete optionsCopy.RecruitLicense;
        delete optionsCopy.RecruitForm;

        if (Array.isArray(optionsCopy.RecruitGrade)) {
            optionsCopy.RecruitGrade = optionsCopy.RecruitGrade.flatMap((group) => recruitGradeGroups[group] || []);
        }

        let options = Object.keys(optionsCopy).length === 0 ? null : optionsCopy;
        const optionLikeRight =
            checkedLikeRightValues && Object.keys(checkedLikeRightValues).length === 0 ? null : checkedLikeRightValues;
        const method = Object.keys(applyMethod || {}).length === 0 ? null : applyMethod;

        if (options && Array.isArray(options.RegionGu)) {
            const filteredRegionGu = options.RegionGu.filter((value) => {
                const numValue = parseInt(value);
                const isDivisibleBy100 = Number.isInteger(numValue) && numValue % 100 === 0;
                const endsWithZeros = value.endsWith('00');
                return !isDivisibleBy100 && !endsWithZeros;
            });

            if (filteredRegionGu.length === 0) {
                const { RegionGu, ...restOptions } = options;
                options = Object.keys(restOptions).length === 0 ? null : restOptions;
            } else {
                options = { ...options, RegionGu: filteredRegionGu };
            }
        }

        postPAEAA010list({
            options,
            optionLikeRight,
            applyMethod: viewImmediate
                ? {
                    ApplyMethod1: ['001'],
                }
                : method,
            subwayPost: Array.isArray(subwayPost) ? subwayPost.filter((post) => post !== '100') : subwayPost || null,
            subwayNum,
            expMin,
            expMax,
            startDate: startDateFormat,
            endDate: endDateFormat,
            // size: currentPage === 1 ? null : size,
            size,
            page: currentPage,
            sortBy,
            ...(sortBy === 'RecruitEnd' && { sortType: 'DESC' }),
        })
            .then(({ data }) => {
                setResults(data.data.list);
                setPages(data.info);
                setDataConFig({
                    countFixed: data.data.countFixed,
                    bannerConfig: data.data.bannerConfig,
                });
            })
            .catch((error) => console.log(error))
            .finally(() => {
                setLoading(false);
                setSearchSuccess(true);
                setTimeout(() => setSearchSuccess(false), 2000);
            });
    };

    const handleSearchClick = () => {
        setViewImmediate(false);
        setSearchParams({ ...searchParams, page: 1 });
        if (viewImmediate === false) {
            getListData(1);
        }
    };

    const handleViewImmediate = () => {
        setViewImmediate(true);
        setSearchParams({ ...searchParams, page: 1 });
        if (viewImmediate === true) {
            getListData(1);
        }
    };

    useEffect(() => {
        getListData();
        // eslint-disable-next-line
    }, [page, size, sortBy, viewImmediate]);

    const [checkedPin, setCheckedPin] = useState(false);
    const handleSelectSavedCondition = (index) => {
        setCheckedPin(true);

        const item = savedConditions[index];
        if (!item) return;

        const {
            checkedStoreValues,
            checkedLikeRightStoreValues,
            startStoreDate,
            endStoreDate,
            checkedStoreLabels,
            applyMethodStore,
        } = item;

        if (typeof item.activeTabIndex === 'number') {
            setActiveTabIndex(item.activeTabIndex);
        }
        if (typeof item.activeTabCheckbox !== 'undefined') {
            setActiveTabCheckbox(item.activeTabCheckbox);
        }
        if (typeof item.activeTabCheckbox2 !== 'undefined') {
            setActiveTabCheckbox2(item.activeTabCheckbox2);
        }

        setCheckedValues(checkedStoreValues);
        setCheckedLikeRightValues(checkedLikeRightStoreValues);
        setStartDate(startStoreDate);
        setEndDate(endStoreDate);
        setCheckedLabels(checkedStoreLabels);
        setApplyMethod(applyMethodStore);

        const keywordSet = new Set();
        if (
            checkedLikeRightStoreValues &&
            !checkedLikeRightStoreValues['RecruitClass'] &&
            !checkedLikeRightStoreValues['RecruitPosition']
        ) {
            Object.values(checkedLikeRightStoreValues).forEach((keywords) => {
                keywords.forEach((keyword) => keywordSet.add(keyword));
            });
        }
        setKeywords([...keywordSet]);
    };

    const openPopup = (data) => {
        if (decode?.authorities === 'ROLE_P') {
            setPopupData(data);
            setIsPopupOpen(true);
        } else if (decode?.authorities === 'ROLE_C') {
            window.alert('개인회원만 이용가능합니다.');
        } else {
            window.alert('로그인 후 이용가능합니다.');
        }
    };

    const closePopup = () => {
        setPopupData(null);
        setIsPopupOpen(false);
    };

    // tab 3
    const [checkedRegionSi, setCheckedRegionSi] = useState(null);
    const communesToRenderTab3 = checkedValues?.RegionSi?.[0]
        ? recruitCommunes[checkedValues.RegionSi[0]]
        : recruitCommunes[checkedRegionSi] || [];
    const renderTabCheckbox2 = getOptions('SubwayPost');

    const filterSubwayPost = (value) => {
        setFilteredSubwayPost(subwayPost.filter((item) => item.desct === value));
    };

    useEffect(() => {
        const options = arrTabCheckbox[activeTabCheckbox];
        if (options?.length > 0 && options[0]?.value && !checkedPin) {
            setCheckedValues((prev) => ({
                ...prev,
                RegionSi: [options[0]?.value],
            }));
            setCheckedRegionSi(options[0]?.value);
        }
    }, [activeTabCheckbox]);

    useEffect(() => {
        if (communesToRenderTab3?.length > 0 && communesToRenderTab3[0]?.code && activeTabIndex === 2 && !checkedPin) {
            setCheckedValues((prev) => ({
                ...prev,
                RegionGu: [communesToRenderTab3[0]?.code],
            }));
        }
    }, [activeTabCheckbox, communesToRenderTab3]);

    const handleRegionSiClick = (value) => {
        setCheckedPin(false);
        setCheckedRegionSi(value);
    };

    useEffect(() => {
        if (filteredSubwayPost && filteredSubwayPost.length > 0 && activeTabIndex === 2 && !checkedPin) {
            setCheckedValues((prev) => ({
                ...prev,
                SubwayPost: [filteredSubwayPost[0].code],
            }));
        }
    }, [filteredSubwayPost]);

    // lấy data radiobox cho 역세권
    useEffect(() => {
        if (!checkedPin) {
            setNum(
                getOptions(`SubwayNum00${activeTabCheckbox2 < 2 ? activeTabCheckbox2 + 1 : activeTabCheckbox2 + 2}`),
            );
        }
        // eslint-disable-next-line
    }, [activeTabCheckbox2, dataSubway]);

    // lấy data checkbox cho 역세권
    const handleNumClick = (value) => {
        setCheckedPin(false);
        filterSubwayPost(value);
    };

    useEffect(() => {
        filterSubwayPost(checkedValues?.subwayNum?.[0]);
        const options = arrTabCheckbox2[activeTabCheckbox2];
        if (options && options.length > 0 && !checkedPin) {
            setCheckedValues((prev) => ({
                ...prev,
                subwayNum: [options[0].value],
            }));
        }
        // eslint-disable-next-line
    }, [num]);

    useEffect(() => {
        if (checkedValues?.subwayNum?.[0]) {
            filterSubwayPost(checkedValues?.subwayNum?.[0]);
        }
    }, [checkedValues?.subwayNum?.[0]]);

    return (
        <>
            <div id="content">
                <Nav menu={MENU_RECRUIT} />
                <div id="tabs-form" className="container">
                    <div className="top-form">
                        <h2>통합</h2>
                        <div ref={popupRef}>
                            <button
                                id="saved-conditions"
                                data-type="popup"
                                onClick={() => {
                                    if (
                                        window.location.pathname !== '/login' &&
                                        window.location.pathname !== '/' &&
                                        !loggedIn
                                    ) {
                                        if (
                                            window.confirm(
                                                `회원전용입니다.\n로그인 하신후 이용하실 수 있습니다.\n로그인하시겠습니까?`,
                                            )
                                        ) {
                                            navigate('/login');
                                        } else {
                                            alert(`회원이 아닌경우 회원가입후 이용가능합니다.`);
                                            navigate('/');
                                        }
                                    }
                                    setSavedConditionsPopup(!savedConditionsPopup);
                                }}
                            >
                                <span>저장한 조건 보기</span>
                                <i className="icon icon-down" />
                            </button>
                            <div className={`popup ${savedConditionsPopup ? 'active' : ''}`} htmlFor="saved-conditions">
                                <button
                                    className="popup-close"
                                    onClick={() => {
                                        setSavedConditionsPopup(false);
                                    }}
                                />
                                <div className="popup-header">
                                    최근 저장한 검색 조건<span>(보관은 최대 5개까지 가능)</span>
                                </div>
                                <div className="popup-content">
                                    <ul className="table table-content">
                                        <li className="row-name-column">
                                            <div className="column start">검색조건</div>
                                            <div className="column start">검색일</div>
                                            <div className="column">삭제</div>
                                        </li>
                                        {savedConditions.length > 0 &&
                                            savedConditions.map((item, index) => (
                                                <li key={index}>
                                                    <ul
                                                        className="wrap-link"
                                                        onClick={() => {
                                                            handleSelectSavedCondition(index);
                                                        }}
                                                    >
                                                        {Array.isArray(item.checkedStoreLabels) &&
                                                            item.checkedStoreLabels.map((label, index) => (
                                                                <li key={index}>{label}</li>
                                                            ))}
                                                    </ul>
                                                    <span className="date">{item.savedStoreDate}</span>
                                                    <button
                                                        className="delete"
                                                        onClick={() => {
                                                            dispatch(deleteFilterPAEAA010Conditions(index));
                                                            dispatch(saveMatchingConditions(decode.seq));
                                                        }}
                                                    >
                                                        <i className="icon icon-trash"></i>
                                                    </button>
                                                </li>
                                            ))}
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                    <Tabs
                        tabs={[
                            { label: '지역 선택', icon: 'icon-location', isActive: true },
                            { label: '업무 선택', icon: 'icon-bag', isActive: false },
                            { label: '상세조건', icon: 'icon-plus', isActive: false },
                        ]}
                        blackTab
                        onTabChange={handleTabChange}
                        indexTabchange={activeTabIndex}
                    />
                    {activeTabIndex === 0 && (
                        <>
                            <div className="tab tabs-select">
                                <div className="tabs-flex">
                                    <div className="tabs-left">
                                        <ul>
                                            {recruitProvinces.map((province, index) => (
                                                <li
                                                    className={province.code === selectedProvince ? 'active' : ''}
                                                    key={index}
                                                    onClick={() => handleProvinceClick(province.code)}
                                                >
                                                    <span className="city-name">{province.codeName}</span>
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                    <div className="tabs-right">
                                        <form>
                                            {communesToRender.length > 0 && (
                                                <>
                                                    <p className="notification">
                                                        지역은 최대 <span>10</span>개까지 선택 가능합니다.
                                                    </p>
                                                    <ul>
                                                        <Checkbox
                                                            name="RegionGu"
                                                            options={communesToRender.map((commune) => ({
                                                                id: 'regionGu_' + commune.code,
                                                                value: commune.code,
                                                                label: `${commune.codeName}`,
                                                            }))}
                                                            onChange={handleInputChange}
                                                            checked={checkedValues}
                                                        />
                                                    </ul>
                                                </>
                                            )}
                                        </form>
                                    </div>
                                </div>
                                <div className="bsns-srch">
                                    <Dropdown
                                        placeholder=""
                                        options={[
                                            { value: 'CompanyName', option: '치과명' },
                                            { value: 'Title', option: '제목' },
                                            { value: 'FTS_Contents', option: '내용' },
                                        ]}
                                        name="conditionSearch"
                                        value={conditionSearch}
                                        onChange={handleOptionChange}
                                    />
                                    <input
                                        type="text"
                                        placeholder="검색어를 입력하세요"
                                        onKeyPress={handleInputKeyPress}
                                    />
                                </div>
                            </div>
                        </>
                    )}
                    {activeTabIndex === 1 && (
                        <>
                            <div
                                className={`tab tabs-select tabs-select-bag tab-${recruitClass && recruitClass.length % 4 === 0 ? 4 : 5
                                    }-item`}
                            >
                                <ul>
                                    {recruitClass.map((recruit) => (
                                        <li
                                            key={recruit.code}
                                            onClick={() => handleCheckRecruitClass(recruit.code)}
                                            className={
                                                checkedLikeRightValues?.['RecruitClass']?.includes(recruit.code)
                                                    ? 'active'
                                                    : ''
                                            }
                                        >
                                            {recruit.codeName}
                                        </li>
                                    ))}
                                </ul>
                                <div className="bsns-srch">
                                    <Dropdown
                                        placeholder=""
                                        options={[
                                            { value: 'CompanyName', option: '치과명' },
                                            { value: 'Title', option: '제목' },
                                            { value: 'FTS_Contents', option: '내용' },
                                        ]}
                                        name="conditionSearch"
                                        value={conditionSearch}
                                        onChange={handleOptionChange}
                                    />
                                    <input
                                        type="text"
                                        placeholder="검색어를 입력하세요"
                                        onKeyPress={handleInputKeyPress}
                                    />
                                </div>
                            </div>
                        </>
                    )}
                    {activeTabIndex === 2 && (
                        <div className="tab tabs-content tabs-select-plus">
                            <div className="wrap-select-plus-child">
                                <div className="title-detailed">사업장</div>
                                <ul className="tab-check-box">
                                    <Checkbox
                                        name="CompanyType"
                                        options={getOptions('CompanyType')}
                                        onChange={handleInputChange}
                                        checked={checkedValues}
                                    />
                                </ul>
                            </div>
                            <div className="wrap-select-plus-child benefit">
                                <div className="title-detailed">업무</div>
                                <ul className="tab-check-box">
                                    <Checkbox
                                        name="RecruitClass"
                                        options={getOptions('RecruitClass')}
                                        onChange={handleInputChange}
                                        checked={checkedLikeRightValues}
                                    />
                                </ul>
                            </div>
                            <div className="wrap-select-plus-child">
                                <div className="title-detailed">자격증</div>
                                <ul className="tab-check-box">
                                    <Checkbox
                                        name="RecruitLicense"
                                        options={getOptions('RecruitLicense')}
                                        onChange={handleInputChange}
                                        checked={checkedLikeRightValues}
                                    />
                                </ul>
                            </div>
                            <div className="wrap-select-plus-child">
                                <div className="title-detailed">근무형태</div>
                                <ul className="tab-check-box">
                                    <Checkbox
                                        name="RecruitForm"
                                        options={getOptions('RecruitForm')}
                                        onChange={handleInputChange}
                                        checked={checkedLikeRightValues}
                                    />
                                </ul>
                            </div>
                            <div className="wrap-select-plus-child">
                                <div className="title-detailed">직급</div>
                                <ul className="tab-check-box">
                                    <Checkbox
                                        name="RecruitPosition"
                                        options={getOptions('RecruitPosition')}
                                        onChange={handleInputChange}
                                        checked={checkedLikeRightValues}
                                    />
                                </ul>
                            </div>
                            <div className="wrap-select-plus-child">
                                <div className="title-detailed">급여</div>
                                <ul className="tab-check-box">
                                    <Checkbox
                                        name="RecruitPay"
                                        options={getOptions('RecruitPay')}
                                        onChange={handleInputChange}
                                        checked={checkedValues}
                                    />
                                </ul>
                            </div>
                            <div className="wrap-select-plus-child">
                                <div className="title-detailed">학력</div>
                                <ul className="tab-check-box">
                                    <Checkbox
                                        name="RecruitGrade"
                                        options={getOptions('RecruitGrade')}
                                        onChange={handleInputChange}
                                        checked={checkedValues}
                                    />
                                </ul>
                            </div>
                            <div className="wrap-select-plus-child">
                                <div className="title-detailed" style={{ display: 'flex', alignItems: 'center' }}>
                                    경력
                                </div>
                                <div className="group">
                                    <ul className="tab-check-box">
                                        <Checkbox
                                            name="RecruitCareer"
                                            options={getOptions('RecruitCareer')}
                                            onChange={handleInputChange}
                                            checked={checkedValues}
                                        />
                                    </ul>
                                    {Array.isArray(checkedValues?.RecruitCareer) &&
                                        checkedValues.RecruitCareer.includes('경력') && (
                                            <>
                                                (
                                                <Dropdown
                                                    placeholder="경력기간선택"
                                                    options={getOptions('RecruiteCareerYear').filter(
                                                        (option) =>
                                                            parseInt(option.value, 10) <
                                                            parseInt(checkedValues.expMax || '999', 10),
                                                    )}
                                                    name={'ExpMin'}
                                                    onChange={handleOptionChange}
                                                />
                                                ~
                                                <Dropdown
                                                    placeholder="경력기간선택"
                                                    options={getOptions('RecruiteCareerYear').filter(
                                                        (option) =>
                                                            parseInt(option.value, 10) >
                                                            parseInt(checkedValues.expMin || '0', 10),
                                                    )}
                                                    name={'ExpMax'}
                                                    onChange={handleOptionChange}
                                                />
                                                )
                                            </>
                                        )}
                                </div>
                            </div>
                            <div className="wrap-select-plus-child benefit">
                                <div className="title-detailed">복리후생</div>
                                <ul className="tab-check-box">
                                    <Checkbox
                                        name="Assist1"
                                        options={getOptions('Assist1')}
                                        onChange={handleInputChange}
                                        checked={checkedValues}
                                    />
                                    <Checkbox
                                        name="Assist2"
                                        options={getOptions('Assist2')}
                                        onChange={handleInputChange}
                                        checked={checkedValues}
                                    />
                                    <Checkbox
                                        name="Assist3"
                                        options={getOptions('Assist3')}
                                        onChange={handleInputChange}
                                        checked={checkedValues}
                                    />
                                    <Checkbox
                                        name="Assist4"
                                        options={getOptions('Assist4')}
                                        onChange={handleInputChange}
                                        checked={checkedValues}
                                    />
                                    <Checkbox
                                        name="Assist5"
                                        options={getOptions('Assist5')}
                                        onChange={handleInputChange}
                                        checked={checkedValues}
                                    />
                                </ul>
                            </div>
                            <div className="wrap-select-plus-child">
                                <div className="title-detailed">근무요일</div>
                                <ul className="tab-check-box">
                                    <Checkbox
                                        name="RecruitDay"
                                        options={getOptions('RecruitDay')}
                                        onChange={handleInputChange}
                                        checked={checkedValues}
                                    />
                                </ul>
                            </div>
                            <div className="wrap-select-plus-child">
                                <div className="title-detailed">접수방법</div>
                                <ul className="tab-check-box">
                                    <Checkbox
                                        name="ApplyMethod"
                                        options={getOptions('ApplyMethod')}
                                        onChange={handleInputChange}
                                        checked={applyMethodChecked}
                                    />
                                </ul>
                            </div>
                            <div className="wrap-select-plus-child">
                                <div className="title-detailed">채용기간</div>
                                <div className="group-datepicker">
                                    <div className="datepicker-child">
                                        <DatePicker
                                            ref={startDateRef}
                                            onChange={(date) => handleDateChange(date, 'startDate')}
                                            locale={'ko'}
                                            placeholderText={'YYYY/MM/DD'}
                                            dateFormat={'yyyy/MM/dd'}
                                            selected={startDate}
                                            maxDate={endDate || null}
                                        />
                                        <i
                                            className="icon icon-date"
                                            id="start-date-icon"
                                            onClick={() => startDateRef.current.setFocus()}
                                        />
                                    </div>
                                    <span>~</span>
                                    <div className="datepicker-child">
                                        <DatePicker
                                            ref={endDateRef}
                                            onChange={(date) => handleDateChange(date, 'endDate')}
                                            locale={'ko'}
                                            placeholderText={'YYYY/MM/DD'}
                                            dateFormat={'yyyy/MM/dd'}
                                            selected={endDate}
                                            minDate={startDate || null}
                                        />
                                        <i
                                            className="icon icon-date"
                                            id="end-date-icon"
                                            onClick={() => endDateRef.current.setFocus()}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="wrap-select-plus-child wrap-tabs-checkbox">
                                <div className="title-detailed" style={{ marginTop: '7px' }}>
                                    지역
                                </div>
                                <ul className="tab-check-box" style={{ width: '100%' }}>
                                    <div className="tabs-flex" style={{ flexDirection: 'column', width: '100%' }}>
                                        <div className="tabs-left" style={{ width: '100%' }}>
                                            <Tabs
                                                className="tabs-select-checkbox"
                                                tabs={tabCheckbox}
                                                onTabChange={handleTabSelectCheckbox}
                                                resetTrigger={resetTrigger}
                                                indexTabchange={activeTabCheckbox}
                                            />
                                            {arrTabCheckbox[activeTabCheckbox]?.length > 0 && (
                                                <>
                                                    <ul>
                                                        <Radiobox
                                                            className="arrTabCheckbox"
                                                            name="RegionSi"
                                                            options={arrTabCheckbox[activeTabCheckbox]}
                                                            onChange={handleInputChange}
                                                            checked={{
                                                                ...checkedValues,
                                                                RegionSi: checkedValues.RegionSi || checkedRegionSi,
                                                            }}
                                                        />
                                                    </ul>
                                                </>
                                            )}
                                        </div>
                                        <div className="tabs-right" style={{ paddingTop: '0px', width: '100%' }}>
                                            <form style={{ width: '100%' }}>
                                                {arrTabCheckbox[activeTabCheckbox] && (
                                                    <>
                                                        <ul className="tabs-select-checkbox">
                                                            <Checkbox
                                                                name="RegionGu"
                                                                options={(communesToRenderTab3 || []).map(
                                                                    (commune) => ({
                                                                        id: 'regionGu_' + commune.code,
                                                                        value: commune.code,
                                                                        label: `${commune.codeName}`,
                                                                    }),
                                                                )}
                                                                onChange={handleInputChange}
                                                                checked={{
                                                                    ...checkedValues,
                                                                    RegionGu: checkedValues.RegionGu || [],
                                                                }}
                                                            />
                                                        </ul>
                                                    </>
                                                )}
                                            </form>
                                        </div>
                                    </div>
                                </ul>
                            </div>
                            <div className="wrap-select-plus-child wrap-tabs-checkbox">
                                <div className="title-detailed" style={{ marginTop: '7px' }}>
                                    역세권
                                </div>
                                <ul className="tab-check-box" style={{ width: '100%' }}>
                                    <div className="tabs-flex" style={{ flexDirection: 'column', width: '100%' }}>
                                        <div className="tabs-left" style={{ width: '100%' }}>
                                            <Tabs
                                                className="tabs-select-checkbox"
                                                tabs={tabCheckbox2}
                                                onTabChange={handleTabSelectCheckbox2}
                                                resetTrigger={resetTrigger}
                                                indexTabchange={activeTabCheckbox2}
                                            />
                                            {arrTabCheckbox2[activeTabCheckbox2]?.length > 0 && (
                                                <>
                                                    <ul className="wrap-arrTabCheckbox2">
                                                        <Radiobox
                                                            className="arrTabCheckbox2"
                                                            name="subwayNum"
                                                            options={arrTabCheckbox2[activeTabCheckbox2]}
                                                            onChange={handleInputChange}
                                                            checked={{
                                                                ...checkedValues,
                                                                subwayNum: checkedValues.subwayNum,
                                                            }}
                                                        />
                                                    </ul>
                                                </>
                                            )}
                                        </div>
                                        <div className="tabs-right" style={{ paddingTop: '0px', width: '100%' }}>
                                            <form style={{ width: '100%' }}>
                                                {arrTabCheckbox2[activeTabCheckbox2]?.length > 0 && (
                                                    <>
                                                        <ul className="tabs-select-checkbox">
                                                            <Checkbox
                                                                name="SubwayPost"
                                                                options={renderTabCheckbox2}
                                                                onChange={handleInputChange}
                                                                checked={{
                                                                    ...checkedValues,
                                                                    SubwayPost: checkedValues.SubwayPost,
                                                                }}
                                                            />
                                                        </ul>
                                                    </>
                                                )}
                                            </form>
                                        </div>
                                    </div>
                                </ul>
                            </div>
                        </div>
                    )}

                    <div className="tab-select-results">
                        <ul className="results-area">
                            {checkedLabels.map((label, index) => (
                                <li key={index}>
                                    <div className="item-search">{label}</div>
                                    <span
                                        className="item-remove icon icon-x"
                                        onClick={() => handleRemoveLabel(label)}
                                    ></span>
                                </li>
                            ))}
                        </ul>
                        <div className="wrap-option-search-block">
                            <button
                                onClick={handleSearchClick}
                                disabled={loading}
                                style={{
                                    position: 'relative',
                                    opacity: loading ? 0.85 : 1,
                                    transition: 'all 0.2s',
                                    cursor: loading ? 'not-allowed' : 'pointer',
                                }}
                            >
                                {loading ? (
                                    <>
                                        <span
                                            style={{
                                                display: 'inline-block',
                                                width: '14px',
                                                height: '14px',
                                                border: '2px solid rgba(255,255,255,0.4)',
                                                borderTop: '2px solid #fff',
                                                borderRadius: '50%',
                                                animation: 'spin 0.7s linear infinite',
                                                marginRight: '6px',
                                                verticalAlign: 'middle',
                                            }}
                                        />
                                        검색 중...
                                    </>
                                ) : searchSuccess ? (
                                    <>
                                        <span style={{ marginRight: '4px' }}>✓</span>
                                        검색 완료
                                    </>
                                ) : (
                                    <>
                                        선택한 조건으로<span>검색하기</span>
                                    </>
                                )}
                            </button>
                            <div className="wrap-option-search">
                                <div className="option-reset icon icon-reset" onClick={handleResetConditions}>
                                    조건 초기화
                                </div>
                                <div className="option-save icon icon-pin" onClick={handleSaveConditions}>
                                    조건 저장
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <GrandBanner />
                {/* Content Table */}
                <div id="support-now">
                    <div className="container">
                        <div className="wrap-table">
                            <div className="header-table-container">
                                <div className="top-table top-table--mt45">
                                    <div className="top-table-title">
                                        <h1>검색결과</h1>
                                        <span>Search Results 전체 {pages?.totalRow}건</span>
                                    </div>
                                    <div className="wrap-dropDown">
                                        <div className="count-results blue" onClick={handleViewImmediate}>
                                            즉시지원만 보기
                                        </div>
                                        <div className="dropDowns">
                                            <Dropdown
                                                placeholder=""
                                                options={[
                                                    { value: 'AddDate', option: '등록일순' },
                                                    { value: 'ModDate', option: '업데이트순' },
                                                    { value: 'RecruitEnd', option: '마감일순' },
                                                ]}
                                                name="sortBy"
                                                value={sortBy}
                                                onChange={handleOptionChange}
                                                className={'form-select-container--ver2'}
                                            />
                                            <Dropdown
                                                placeholder=""
                                                options={[
                                                    { value: 50, option: '50개씩 보기' },
                                                    { value: 80, option: '80개씩 보기' },
                                                    { value: 100, option: '100개씩 보기' },
                                                ]}
                                                name="size"
                                                value={size}
                                                onChange={handleOptionChange}
                                                className={'form-select-container--ver2'}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="table table-header">
                                    <div className="column column-1">치과명</div>
                                    <div className="column column-3">
                                        <div>
                                            제목/담당업무/위치
                                        </div>
                                        <div>경력/형태/자격증/수정</div>
                                        <div>마감일</div>
                                    </div>
                                </div>
                            </div>
                            <RecruitList
                                loading={loading}
                                results={results}
                                recruitBanner={recruitBanner}
                                dataConFig={dataConFig}
                                openPopup={openPopup}
                                page={page}
                                setRecruitList={setResults}
                            />

                            <PaginationCustom pages={pages} />
                        </div>
                    </div>
                </div>
            </div>
            {isPopupOpen && <PAEAA060 popupData={popupData} closePopup={closePopup} />}
        </>
    );
};
export default PAEAA010;
